export const catalogInitialState = () => ({
  services: [],
  modalities: [],
  frequencies: [],
  durations: [],
  approaches: [],
  teachers: [],
  places: [],
});

export const modelInitialState = () => ({
  id: null,
  service: null,
  other: null,
  modality: null,
  frequency: null,
  duration: null,
  dutyTime: null,
  approach: null,
  teacher: null,
  equipment: null,
  place: null,
  comment: null,
  commentCreatedBy: null,
  commentDate: null,
  commentedByUsername: null,
  commentedByRoleName: null,
});

export const modelToPayload = (
  tapRequestId,
  {
    id,
    service,
    other,
    modality,
    frequency,
    duration,
    dutyTime,
    approach,
    teacher,
    equipment,
    place,
    comment,
  }
) => ({
  requestId: tapRequestId,
  id: id,
  disciplineTypeId: service?.id,
  otherServiceDescription: other || null,
  modalityTypeId: modality?.id || null,
  frequencyTypeId: frequency?.id || null,
  durationTypeId: duration?.id || null,
  serviceTime: dutyTime || null,
  approachTypeId: approach?.id || null,
  teacherTypeId: teacher?.id || null,
  assignedEquipment: equipment || null,
  equipmentUtilizationLocationId: place?.id || null,
  comment: comment || null,
});

export const payloadToModel = ({
  id,
  disciplineTypeId,
  disciplineType,
  otherServiceDescription,
  modalityTypeId,
  modalityType,
  frequencyTypeId,
  frequencyType,
  durationTypeId,
  durationType,
  serviceTime,
  approachTypeId,
  approachType,
  teacherTypeId,
  teacherType,
  assignedEquipment,
  equipmentUtilizationLocationId,
  equipmentUtilizationLocation,
  comment,
  Comment,
  commentCreatedBy,
  CommentCreatedBy,
  commentDate,
  CommentDate,
  commentedByUsername,
  CommentedByUsername,
  commentedByRoleName,
  CommentedByRoleName,
  isValidForTapRelated,
  isValidForTapSupplementary,
}) => ({
  id: id,
  service: disciplineTypeId
    ? { id: disciplineTypeId, name: disciplineType }
    : null,
  other: otherServiceDescription || null,
  modality: modalityTypeId ? { id: modalityTypeId, name: modalityType } : null,
  frequency: frequencyTypeId
    ? { id: frequencyTypeId, name: frequencyType }
    : null,
  duration: durationTypeId ? { id: durationTypeId, name: durationType } : null,
  dutyTime: serviceTime || null,
  approach: approachTypeId ? { id: approachTypeId, name: approachType } : null,
  teacher: teacherTypeId ? { id: teacherTypeId, name: teacherType } : null,
  equipment: assignedEquipment || null,
  place: equipmentUtilizationLocationId
    ? {
        id: equipmentUtilizationLocationId,
        name: equipmentUtilizationLocation,
      }
    : null,
  // Mapear de PascalCase del backend a camelCase
  comment: comment || Comment || null,
  commentCreatedBy: commentCreatedBy || CommentCreatedBy || null,
  commentDate: commentDate || CommentDate || null,
  commentedByUsername: commentedByUsername || CommentedByUsername || null,
  commentedByRoleName: commentedByRoleName || CommentedByRoleName || null,
  isValidForTapRelated,
  isValidForTapSupplementary,
});

//* These can be used to filter items and services as they use the same flags (isValidForTapRelated, isValidForTapSupplementary).

export const isTapRelatedFilter = (x) => x.isValidForTapRelated;

export const isTapSupplementaryFilter = (x) =>
  x.isValidForTapSupplementary && !x.isValidForTapRelated;
